<template>
    <iframe src="https://trade.mql5.com/trade?demo_all_servers=1&amp;servers=FXView-Live,FXView-Live;trade_server=FXView-Demo;startup_mode=create_demo;lang=en&amp;save_password=off;utm_source=www.fxview.com" allowfullscreen="allowfullscreen" style="width: 100%; height: 100%; border: none;"></iframe> 
</template>
<script>
	import { fxViewMixins } from '@/plugins/fxView'
	export default {
        name: 'MT4-TRADE-LINK',
        mixins: [fxViewMixins],
        data() {
            return {
				
            }
        },
        methods:{},
        created(){}
    }
</script>

 


// WEBPACK FOOTER //
// src/components/fxView/tradingAccounts/web_trade_link_live.vue